import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { TOP_BANNER_HEIGHT } from '@/components/Banners/Banners.constants';

export const Box = styled.div<{ $isTopBannerVisible: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 15% 30px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  flex-grow: 1;
  height: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30% 30px 0 30px;
    min-height: ${({ $isTopBannerVisible, theme }) =>
      `calc(100vh - ${
        theme.tabBarHeight +
        TOP_BANNER_HEIGHT +
        ($isTopBannerVisible ? TOP_BANNER_HEIGHT : 0)
      }px)`};
  }
`;

export const Text = styled(Typography.Body)`
  text-align: center;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    max-width: 300px;
  }
`;
